import type { HeaderContent, HeaderPhaseContent } from './types';

export const headerContent: HeaderContent = {
  logo: 'Color Scales I/O',
  navigation: {
    links: [
      { text: 'Features', targetId: 'features-grid' },
      { text: 'Pricing', targetId: 'pricing' },
      { text: 'Install', targetId: 'final-cta' },
    ],
    cta: {
      text: 'Try for free',
      targetId: 'pricing',
    },
  },
};

/**
 * Phase-specific header CTA overrides
 * The Header component uses these based on VITE_LAUNCH_MODE
 */
export const headerPhaseContent: HeaderPhaseContent = {
  preLaunch: {
    cta: { text: 'Get early access', targetId: 'final-cta' },
  },
  beta: {
    cta: { text: 'Try for free', targetId: 'pricing' },
  },
  earlyBird: {
    cta: { text: 'Try for free', targetId: 'pricing' },
  },
  stable: {
    cta: { text: 'Try for free', targetId: 'pricing' },
  },
};

